// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"250f7f49","885":"e68e8251"}[chunkId] + ".chunk.js";
};